import { LADDER } from "../../shared/domain.ts";

const TOTAL = LADDER[LADDER.length - 1]!;

/**
 * The segmented bar showing how much of the Track is unlocked.
 *
 * Segments are sized by their share of the full 30 seconds, so the opening 0.5s
 * is a thin sliver — the bar tells the truth about how little you start with.
 */
export function LadderBar({ stepsSpent }: { stepsSpent: number }) {
  const unlocked = LADDER[Math.min(stepsSpent, LADDER.length - 1)]!;

  return (
    <div className="ladder">
      <div className="ladder__label" key={unlocked}>
        {unlocked} second{unlocked === 1 ? "" : "s"}
      </div>
      <div
        className="ladder__bar"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={TOTAL}
        aria-valuenow={unlocked}
        aria-label="Audio unlocked"
      >
        {LADDER.map((duration, i) => {
          const previous = i === 0 ? 0 : LADDER[i - 1]!;
          return (
            <span
              key={duration}
              className={`ladder__seg${i <= stepsSpent ? " ladder__seg--on" : ""}`}
              style={{ flexGrow: duration - previous }}
            />
          );
        })}
      </div>
    </div>
  );
}
